export default function CardSkeleton() {
  return (
    <div className="animate-pulse flex items-center gap-3 py-3">
      <div className="rounded-full bg-slate-300 h-10 w-10"></div>
      <div className="flex-1 space-y-6 py-1">
        <div className="h-2 bg-slate-300 rounded"></div>
        <div className="space-y-1">
          <div className="grid grid-cols-3 gap-4">
            <div className="h-2 bg-slate-300 rounded col-span-2"></div>
            <div className="h-2 bg-slate-300 rounded col-span-1"></div>
          </div>
        </div>
      </div>
    </div>
  );
}
